export enum TipoDocumentoReembolso {
    NOTA_FISCAL = 1,
    RECIBO = 2,
    RECEITA_MEDICA = 3,
    PEDIDO_MEDICO,  
    DESCRICAO_CIRURGICA = 5,
    GUIA_AUTORIZACAO = 6,
    PLANO_TRATAMENTO =9,
    LAUDO_ANATOMOPATOLOGICO = 10,
    FICHA_ODONTO = 11,
    FICHA_ODONTO_AUDIT = 12,
    PARTOGRAMA = 13,
    FICHA_ANESTESICA = 14,
    FICHA_PEDIATRICA = 15,    
    OUTROS=18
}
